export default function SectionAbout() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
              About
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-5">
              关于每日大赛mrds
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              每日大赛mrds是国内领先的每日吃瓜排位赛平台，专注打造最具影响力的黑料评选社区。
              我们以&ldquo;全民投票、实时排行&rdquo;为核心机制，将全网最热门的娱乐梗图、爆料资讯和热点话题汇聚一处，
              让每一位吃瓜群众都能参与投票，决定今日瓜王归属。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台每日更新海量新鲜内容，覆盖娱乐日报评选、每日梗图评选、吃瓜排位赛等多个维度。
              无论是追踪最新热点话题，还是挖掘隐藏的黑料梗，每日大赛mrds都是你最值得信赖的吃瓜指南。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们坚持客观公正的评选机制，所有榜单由社区真实投票产生，拒绝人工干预，确保每一条爆料排行的公信力。
            </p>
          </div>
          <div className="flex-1 w-full max-w-[480px]">
            <div className="rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20a%20community%20voting%20and%20ranking%20concept%2C%20abstract%20hands%20raising%20cards%20with%20stars%2C%20trophy%20and%20podium%20elements%2C%20warm%20crimson%20and%20soft%20gold%20accents%2C%20clean%20modern%20flat%20style%2C%20friendly%20community%20vibe%2C%20entertainment%20theme%2C%20no%20text%2C%20simple%20warm%20background&width=800&height=600&seq=mrds-about-01&orientation=landscape"
                alt="每日大赛mrds社区投票评选概念图"
                className="w-full h-auto object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}